import axios from "axios";

// Use a relative path so the frontend always talks to the same origin it's served from.
// Works on the preview URL, on `naamikitchens.com`, and on any future domain — no rebuild needed.
export const API = "/api";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const trackEvent = (event_type, { brand_id, brand_name, platform } = {}) => {
  try {
    // Lightweight fire-and-forget — placeholder for GA4
    api.post("/track", { event_type, brand_id, brand_name, platform }).catch(() => {});
    if (window.dataLayer) {
      window.dataLayer.push({ event: event_type, brand_id, brand_name, platform });
    }
  } catch (_) {
    /* noop */
  }
};
